import { combineReducers } from 'redux'

import resultados from './detalhesAdvertenciaFornecedor'

export default combineReducers({ resultados })
